var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("p", { staticClass: "title" }, [_vm._v("一键点亮粉丝勋章")]),
      _vm._v(" "),
      _c(_setup.TextBox, {
        attrs: {
          placeholder: "直播间ID",
          text: _setup.roomid,
          "change-on-blur": true,
        },
        on: { change: _setup.handleRoomIdChange },
      }),
      _vm._v(" "),
      _c(_setup.TextBox, {
        attrs: {
          placeholder: "点赞次数",
          text: _setup.clickTimes,
          "change-on-blur": true,
        },
        on: { change: _setup.handleClickTimesChange },
      }),
      _vm._v(" "),
      _c(_setup.AsyncButton, { on: { click: _setup.handleKeepAliveRequest } }, [
        _vm._v("点亮!"),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }